import { IsString, IsUUID, Length, IsOptional, MaxLength, IsNotEmpty } from "class-validator";

export class UserAddress {
	@MaxLength(100)
	@IsNotEmpty()
	street: string;

	@MaxLength(100)
	@IsNotEmpty()
	number: string;

	@IsOptional()
	@MaxLength(100)
	@IsNotEmpty()
	complement: string;

	@MaxLength(100)
	@IsNotEmpty()
	district: string;

	@MaxLength(100)
	@IsNotEmpty()
	city: string;

	@MaxLength(100)
	@IsNotEmpty()
	state: string;

	@Length(9, 9)
	@IsNotEmpty()
	postalCode: string;

	@IsOptional()
	@IsUUID()
	proofOfResidenceUrl: string;
}
